/* ==========================================================================
   SMOON — Landing « Gamme Coton »
   Onglets produit, carrousels, sélecteurs de variante, paliers de quantité,
   ajout panier AJAX, guide des tailles et apparitions au scroll.
   Vanilla, sans dépendance, idempotent (sûr avec l'éditeur de thème).
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '.gc[data-gc-root]';

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function money(cents) {
    var f = window.Shopify && window.Shopify.money_format;
    var v = (cents / 100).toFixed(2).replace('.', ',');
    if (f && f.indexOf('{{') > -1) {
      return f.replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    return v + ' €';
  }

  /* ------------------------------------------------------------ carrousels
     Le défilement lui-même est natif (scroll-snap) : fluide au swipe et
     accessible. Le JS ne gère que les flèches et les points. */
  function initSlider(vp) {
    if (vp.dataset.gcSliderInit) return;
    vp.dataset.gcSliderInit = '1';

    /* la piste est l'élément lui-même s'il la porte — sinon on descend, mais
       jamais dans un slider imbriqué (un rail de cartes n'est pas la galerie
       d'une de ses cartes) */
    var track = vp.matches('[data-gc-track]') ? vp : null;
    if (!track) {
      var cands = vp.querySelectorAll('[data-gc-track]');
      for (var c = 0; c < cands.length; c++) {
        var owner = cands[c].closest('[data-gc-slider]');
        if (!owner || owner === vp) { track = cands[c]; break; }
      }
    }
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 1) return;

    function scroller() {
      return track.scrollWidth > track.clientWidth + 1 ? track : vp;
    }

    /* les contrôles peuvent vivre dans la piste, à côté, ou plus haut dans la
       section (points d'un carrousel d'avis rendus hors du rail) */
    function ctrl(sel) {
      var scopes = [vp, vp.parentElement, vp.parentElement && vp.parentElement.parentElement, vp.closest('section')];
      for (var i = 0; i < scopes.length; i++) {
        if (!scopes[i]) continue;
        var els = scopes[i].querySelectorAll(sel);
        for (var j = 0; j < els.length; j++) {
          var owner = els[j].closest('[data-gc-slider]');
          if (owner && owner !== vp) continue;
          return els[j];
        }
      }
      return null;
    }

    var dotsBox = ctrl('[data-gc-dots]');
    var prev = ctrl('[data-gc-prev]');
    var next = ctrl('[data-gc-next]');
    var dots = dotsBox ? Array.prototype.slice.call(dotsBox.children) : [];

    /* Position de défilement d'une diapo : on part des offsets réels plutôt
       que d'un pas théorique. Sans ça le padding gauche de la piste (16 px sur
       le rail ado, 40 px sur les avis) décale chaque saut, la diapo n'atteint
       jamais son point d'ancrage et le navigateur la ramène en arrière — la
       flèche semblait « bloquer ». */
    function offsetOf(i) {
      return Math.max(0, slides[i].offsetLeft - slides[0].offsetLeft);
    }

    function current() {
      var sl = scroller().scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var k = 0; k < slides.length; k++) {
        var d = Math.abs(offsetOf(k) - sl);
        if (d < bestDist) { bestDist = d; best = k; }
      }
      return best;
    }

    function paint(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var sc = scroller();
      var noScroll = sc.scrollWidth <= sc.clientWidth + 2;
      if (prev) prev.disabled = noScroll || sc.scrollLeft <= 2;
      if (next) next.disabled = noScroll || sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 2;
    }

    function goTo(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      scroller().scrollTo({ left: offsetOf(i), behavior: smooth === false ? 'auto' : 'smooth' });
      paint(i);
    }

    vp.gcGoTo = goTo;

    var raf;
    function onScroll() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { paint(current()); });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    if (vp !== track) vp.addEventListener('scroll', onScroll, { passive: true });

    /* Une flèche = une carte. Sur un rail qui en montre 2,5, avancer d'une
       « page » sautait des cartes sans qu'on les ait vues. */
    function page(dir) {
      goTo(current() + dir);
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });

    paint(0);
    window.addEventListener('resize', function () { paint(current()); }, { passive: true });
  }

  /* ---------------------------------------------------------------- onglets */
  function initTabs(root) {
    $$('[data-gc-tab]', root).forEach(function (tab) {
      if (tab.dataset.gcInit) return;
      tab.dataset.gcInit = '1';
      tab.addEventListener('click', function () {
        var host = tab.closest('.gc-prod__in') || root;
        $$('[data-gc-tab]', host).forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-gc-panel]', host).forEach(function (p) {
          p.classList.toggle('is-hidden', p.dataset.gcPanel !== tab.dataset.gcTab);
        });
      });
    });
  }

  /* ------------------------------------------ variantes, paliers et panier */
  function initProductForm(scope) {
    if (scope.dataset.gcFormInit) return;
    scope.dataset.gcFormInit = '1';

    var dataEl = scope.querySelector('[data-gc-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = scope.querySelector('[data-gc-variant]');
    var input = scope.querySelector('[data-gc-id]');
    var qtyInput = scope.querySelector('[data-gc-qty]');
    var btn = scope.querySelector('[data-gc-add]');
    var lbl = btn ? btn.querySelector('[data-gc-lbl]') : null;
    var totalEl = scope.querySelector('[data-gc-total]');
    var priceEl = scope.querySelector('[data-gc-price]');
    var gallery = scope.querySelector('[data-gc-slider]');
    var tiers = $$('[data-gc-tier]', scope);
    var qty = 1;

    function variantById(id) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return null;
    }

    var booted = false;

    function sync() {
      var v = variantById(select ? select.value : (input && input.value));
      if (!v) return;
      if (input) input.value = v.id;
      if (qtyInput) qtyInput.value = qty;

      /* la galerie suit la variante choisie : photo portée de la bonne couleur */
      if (booted && gallery && gallery.gcGoTo && data.leadIdx) {
        var idx = data.leadIdx[String(v.id)];
        if (typeof idx === 'number') gallery.gcGoTo(idx);
      }

      if (priceEl) priceEl.textContent = money(v.price);
      /* le total affiché est le prix plein : la remise des packs est calculée
         au panier, comme sur la page d'origine */
      if (totalEl) totalEl.textContent = money(v.price * qty);
      if (btn) {
        btn.disabled = !v.available;
        if (lbl) lbl.textContent = v.available ? (data.labelAdd || '') : (data.labelOut || '');
      }
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        qty = parseInt(t.dataset.gcTier, 10) || 1;
        tiers.forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        sync();
      });
    });

    if (select) select.addEventListener('change', sync);
    sync();
    booted = true;

    /* ajout panier AJAX -> ouvre le tiroir natif du thème */
    var form = scope.querySelector('[data-gc-cart-form]');
    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-load')) return;
      btn.classList.add('is-load');

      var body = new FormData(form);
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && drawer.getSectionsToRender) {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.location.href = form.action; return; }
          if (drawer) {
            if (drawer.classList && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (drawer.renderContents) drawer.renderContents(res);
            if (drawer.open) drawer.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          document.dispatchEvent(new CustomEvent('gc:added', { detail: res }));
        })
        .catch(function () { window.location.href = form.action; })
        .finally(function () { btn.classList.remove('is-load'); });
    });
  }

  /* ------------------------------------------------- guide des tailles
     Les modales sont celles du thème (snippet size-guide-html) : on réutilise
     l'ouverture de <modal-dialog> déjà branchée sur tout le site. */
  function initGuide(root) {
    $$('[data-gc-guide]', root).forEach(function (link) {
      if (link.dataset.gcInit) return;
      link.dataset.gcInit = '1';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var id = link.dataset.gcGuide;
        var modal = document.getElementById(id);
        if (!modal) return;
        if (typeof modal.show === 'function') modal.show(link);
        else modal.setAttribute('open', 'true');
      });
    });
  }

  /* -------------------------------------------- ancres de scroll interne
     Deux entrées : `data-gc-scroll` (boutons de la section) et n'importe quel
     lien interne `href="#..."` saisi dans un réglage. Dans les deux cas on
     décale de la hauteur du header collant, sinon la cible passe dessous. */
  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset - 8;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }

  function initAnchors(root) {
    $$('[data-gc-scroll]', root).forEach(function (a) {
      if (a.dataset.gcInit) return;
      a.dataset.gcInit = '1';
      a.addEventListener('click', function (e) {
        if (scrollToId(a.dataset.gcScroll)) e.preventDefault();
      });
    });

    $$('a[href^="#"]', root).forEach(function (a) {
      if (a.dataset.gcInit) return;
      a.dataset.gcInit = '1';
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (id && scrollToId(id)) e.preventDefault();
      });
    });
  }

  /* ------------------- comparatif : masquer l'aide dès qu'on a fait défiler */
  function initScrollHint(root) {
    $$('[data-gc-scroll-x]', root).forEach(function (box) {
      if (box.dataset.gcInit) return;
      box.dataset.gcInit = '1';
      var hint = box.parentElement ? box.parentElement.querySelector('[data-gc-hint]') : null;
      if (!hint) return;
      function check() {
        if (box.scrollWidth <= box.clientWidth + 2 || box.scrollLeft > 12) hint.style.visibility = 'hidden';
        else hint.style.visibility = '';
      }
      box.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    });
  }

  /* ------------------------------------------------------------ apparitions */
  function initReveal(root) {
    var els = $$('.gc-anim', root).filter(function (el) { return !el.dataset.gcSeen; });
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.dataset.gcSeen = '1'; io.observe(el); });
  }

  /* ------------------------------------------------------------------ boot */
  function boot(root) {
    if (!root) return;
    $$('[data-gc-slider]', root).forEach(initSlider);
    $$('[data-gc-product]', root).forEach(initProductForm);
    initTabs(root);
    initGuide(root);
    initAnchors(root);
    initScrollHint(root);
    initReveal(root);
  }

  function bootAll() { $$(SEL).forEach(boot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* éditeur de thème : la section est réinjectée à chaque modification */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector(SEL) || (e.target.matches && e.target.matches(SEL) ? e.target : null);
    boot(root);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest('[data-gc-panel]');
    if (panel) {
      var host = panel.closest('.gc-prod__in');
      var tab = host ? host.querySelector('[data-gc-tab="' + panel.dataset.gcPanel + '"]') : null;
      if (tab) tab.click();
    }
  });
})();
